import { n2, usd, periodLabel } from "@/lib/finance";

const EXACT = { WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" };
const HL = "bg-[#fff176]";

function Amount({ v, dollar, kind }) {
  if (v == null) return <td className="px-2" />;
  const txt = dollar ? usd(v) : n2(v);
  const base = "px-1 text-right font-mono leading-tight tabular-nums text-slate-900";
  if (kind === "grand") {
    return (
      <td className="px-2 py-0.5">
        <div className="border-t border-slate-900 pt-0.5" style={EXACT}>
          <div className="border-b border-slate-900 pb-[2px]"><div className={`${base} border-b border-slate-900 pb-0.5 font-bold`} data-testid="gc-amount">{txt}</div></div>
        </div>
      </td>
    );
  }
  const cls = {
    subtotal: "border-y border-slate-900 py-0.5 font-bold",
    bfrow: `border-y border-slate-900 py-0.5 font-bold ${HL}`,
    balance: `border-b border-slate-900 py-0.5 font-bold ${HL}`,
  }[kind] || "border-b border-slate-900 pb-0.5";
  return <td className="px-2 py-0.5"><div className={`${base} ${cls}`} style={EXACT} data-testid="gc-amount">{txt}</div></td>;
}

const LABEL = {
  head: "border border-slate-400 font-bold", bfrow: "pl-4 font-semibold", group: "pl-4 font-semibold", item: "pl-10",
  subtotal: "pl-2 font-bold", grand: "pl-2 font-extrabold", balance: "border border-slate-400 font-bold",
};

function Row({ r, L }) {
  const s = r.style;
  if (s === "blank") return <tr className="h-4"><td colSpan={5} /></tr>;
  const gti = s === "grand" && r.label === L.grand_total_income;
  return (
    <tr className={s === "head" ? "border-t-8 border-transparent" : ""} data-testid={`gc-row-${s}`}>
      <td className={`h-8 w-8 px-2 align-middle text-sm font-bold leading-none ${s === "head" || s === "balance" ? "border border-slate-400" : ""}`}>{r.num}</td>
      <td className={`h-8 px-2 align-middle text-sm leading-none ${LABEL[s] || ""}`}>{r.label}</td>
      <Amount v={r.c1} />
      <Amount v={r.c2} kind={s === "subtotal" ? "subtotal" : ""} />
      <Amount v={r.c3} dollar={s === "balance" || gti} kind={s} />
    </tr>
  );
}

export function GcStatement({ model, period, label }) {
  const { L, rows } = model;
  return (
    <div data-testid="gc-statement">
      <p className="no-print mb-2 text-xs text-slate-500 sm:hidden">Swipe sideways to see all columns →</p>
      <div className="overflow-x-auto">
        <div className="border border-slate-400 py-3 text-center text-base font-extrabold uppercase leading-7 text-slate-900 sm:text-lg" data-testid="gc-title">
          <div data-testid="gc-title1">{L.title1}</div>
          <div>{L.title2}</div>
          <div className="normal-case" data-testid="gc-period">{label || periodLabel(period)}</div>
        </div>
        <table className="mt-3 w-full min-w-[620px] border-separate border-spacing-0 text-slate-900">
          <colgroup><col className="w-8" /><col /><col className="w-36" /><col className="w-36" /><col className="w-40" /></colgroup>
          <tbody>{rows.map((r, i) => <Row key={i} r={r} L={L} />)}</tbody>
        </table>
      </div>
    </div>
  );
}
